export const PUBLIC_HOLIDAY_LOCATIONS = [
  { key: 'PL', label: 'Brimit Poland' },
  { key: 'BY', label: 'Brimit Belarus' },
  { key: 'NL', label: 'Brimit Netherlands' },
  { key: 'AE', label: 'Brimit MEA' },
] as const;

export const DEFAULT_LOCATION_KEY = 'BY';

export const HOURS_PER_DAY = 8;

/** Match user location to a holiday location key by label */
export function matchLocationKey(userLocation: string | null | undefined): string {
  if (!userLocation) return DEFAULT_LOCATION_KEY;
  const lower = userLocation.toLowerCase();
  for (const loc of PUBLIC_HOLIDAY_LOCATIONS) {
    if (lower.includes(loc.label.toLowerCase())) return loc.key;
  }
  return DEFAULT_LOCATION_KEY;
}
